module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lunchBoxes"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Lunch Boxes")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.lunchBoxes), function(box) {
    return _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "lunch-box"
    }, [(!box.available_now) ? _c('div', {
      staticClass: "badge alert-danger"
    }, [_vm._v("Not available now")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(box.title))]), _vm._v(" "), _c('p', {
      staticClass: "description text-muted"
    }, [_vm._v(_vm._s(box.description))]), _vm._v(" "), _c('div', {
      staticClass: "items"
    }, _vm._l((box.categories), function(category) {
      return _c('div', {
        staticClass: "item-group"
      }, [_c('h5', [_vm._v(_vm._s(category.title) + " "), _c('span', {
        staticClass: "text-muted"
      }, [_vm._v("(max. " + _vm._s(category.max_products) + ")")])]), _vm._v(" "), _c('div', {
        staticClass: "products"
      }, _vm._l((category.products), function(product) {
        return _c('div', {
          class: ['product', _vm.productIsSelected(box, category, product) ? 'selected' : ''],
          on: {
            "click": function($event) {
              return _vm.addToBox(box, category, product)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(product.title) + "\n                    ")])
      }), 0)])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 note"
    }, [_c('h5', [_vm._v("Note")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Leave a note...")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (box.note),
        expression: "box.note"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Leave a note...",
        "rows": "3"
      },
      domProps: {
        "value": (box.note)
      },
      on: {
        "keyup": function($event) {
          return _vm.noteChanged(box)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(box, "note", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "text-center change-quantity"
    }, [_c('span', {
      staticClass: "plus",
      on: {
        "click": function($event) {
          return _vm.plusQuantity(box)
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "quantity"
    }, [_vm._v(_vm._s(box.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "minus",
      on: {
        "click": function($event) {
          return _vm.minusQuantity(box)
        }
      }
    }, [_vm._v("-")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('b-button', {
      staticClass: "btn-danger",
      attrs: {
        "disabled": !box.available_now
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(box)
        }
      }
    }, [_vm._v("\n                    Add to cart\n                  ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "offer-price"
    }, [(!box.discount) ? _c('span', {
      staticClass: "no-discount"
    }, [_vm._v("£ " + _vm._s(box.price.toFixed(2)))]) : _c('span', {
      staticClass: "has-discount"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("£ " + _vm._s(box.price.toFixed(2)))]), _vm._v(" "), _c('span', {
      staticClass: "discount"
    }, [_vm._v("£ " + _vm._s(box.discount.toFixed(2)))])])])])])])])
  }), _vm._v(" "), (!_vm.lunchBoxes.length) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("There are no available Lunch Box Offers at the moment.")])]) : _vm._e()], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-543574fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lunch-boxes/lunch-boxes.vue
// module id = 552
// module chunks = 1